"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClientRequest_1 = __importDefault(require("../ClientRequest"));
const TimelineApi = {
    getTweetLikeUser: async (tweetId, page) => {
        const res = await ClientRequest_1.default.get(`tweets/${tweetId}/likes?page=${page}`);
        return res.data;
    },
};
exports.default = TimelineApi;
